import { useMemo } from 'react';
import useQuery from 'hooks/useQuery';

const useCheckExistingOnDemandAccess = ({
  carparkId,
  licensePlate,
  token,
}) => {
  // GraphQL query to get all active on-demand accesses
  const query = `
    query CheckExistingOnDemandAccess($input: ListOnDemandAccessesInput!, $search: ListOnDemandAccessesSearchInput) {
      listOnDemandAccesses(input: $input, pagination: { pageNumber: 1, pageSize: 700 }, search: $search) {
        entries {
          id
          licensePlate
          status
          active
        }
      }
    }
  `;

  // Variables for the query - get all active on-demand accesses
  const variables = useMemo(() => {
    if (!carparkId) {
      return null;
    }

    return {
      input: {
        carparkId,
      },
      search: {
        and: [
          {
            active: {
              eq: true,
            },
          },
          {
            or: [
              {
                status: {
                  eq: 'STARTED',
                },
              },
              {
                status: {
                  eq: 'IN_PROGRESS',
                },
              },
              {
                status: {
                  eq: 'IN_OVERSTAY',
                },
              },
            ],
          },
        ],
      },
    };
  }, [carparkId]);

  // Execute the query
  const {
    data: existingOnDemandData,
    loading,
    error,
  } = useQuery({
    query,
    variables,
    token,
    canFetch: !!variables && !!token,
    dependencies: [carparkId, token],
  });

  // Find existing on-demand access for the specific license plate (client-side search)
  const existingOnDemandAccess = useMemo(() => {
    if (!existingOnDemandData || !existingOnDemandData.listOnDemandAccesses || !licensePlate || licensePlate.trim().length < 4) {
      return null;
    }

    const trimmedLicensePlate = licensePlate.trim().toLowerCase();
    return existingOnDemandData.listOnDemandAccesses.entries.find(
      (entry) => entry.licensePlate && entry.licensePlate.toLowerCase() === trimmedLicensePlate,
    ) || null;
  }, [existingOnDemandData, licensePlate]);

  const hasActiveOnDemandAccess = useMemo(() => !!existingOnDemandAccess, [existingOnDemandAccess]);

  return {
    existingOnDemandData,
    existingOnDemandAccess,
    hasActiveOnDemandAccess,
    loading,
    error,
  };
};

export default useCheckExistingOnDemandAccess;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/onDemand/hooks/useCheckExistingOnDemandAccess.js